/** @jsxImportSource @emotion/react */
import React from "react";
import { Input } from "antd";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import { debounce } from "lodash";
import { searchStyle } from "./styles";

export interface ToolboxSearchProps {
  onSearch: (keyword: string) => void;
  placeholder?: string;
  width?: number;
  size?: SizeType;
  enterButton?: React.ReactNode;
  debounceMs?: number;
}

export const ToolboxSearch: React.FC<ToolboxSearchProps> = ({
  onSearch,
  placeholder = "search...",
  width = 300,
  size = "large",
  enterButton = true,
  debounceMs = 300,
}: ToolboxSearchProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onChange = React.useCallback(
    debounce((event: React.ChangeEvent<HTMLInputElement>) => {
      onSearch(event.target.value);
    }, debounceMs),
    [onSearch, debounceMs],
  );

  return (
    <Input.Search
      css={searchStyle(size)}
      placeholder={placeholder}
      allowClear
      style={{ width, verticalAlign: "middle" }}
      size={size}
      onChange={onChange}
      enterButton={enterButton}
    />
  );
};
